<template>
    <b-overlay :show="overlayShow" rounded="sm" class="card">
        <div
            :class="{
                'card-body': true,
                'p-0': noPadding,
                'state-completed': state === 'completed',
                'state-disabled': state === 'disabled',
            }"
        >
            <div v-if="!(blankLoading && loading) && ((header || $slots.header) || ($slots.nav))" class="mt-0 mb-1" :class="{'border-bottom p-3': headerBorder, 'sticky-header': stickyHeader}">
                <!--
                @slot Alternative to `header` prop
                -->
                <div class="d-flex gap-4">
                    <h4 v-if="(header || $slots.header)" class="header-title">
                        <slot name="header">
                            <span :id="headerId" class="text-link-header">
                                <Tooltip v-if="tooltip" :text="tooltip" type="info" icon-variant="secondary" class="ml-1">{{ $t(header) }}</Tooltip>
                                <template v-else>{{ header }}</template>
                            </span>
                        </slot>
                        <Tooltip v-if="tooltip && $slots.header" :text="tooltip" type="info" icon-variant="secondary" class="ml-1">{{ $t(header) }}</Tooltip>
                    </h4>
                    <div v-if="$slots.nav" class="font-weight-normal ml-auto">
                        <slot name="nav"></slot>
                    </div>
                </div>
            </div>

            <p v-if="!(blankLoading && loading) && (subHeader || $slots.subHeader) && state !== 'disabled'" class="mt-2 sub-header">
                <!--
                @slot Alternative to `subHeader` prop
                -->
                <slot name="subHeader">
                    {{ subHeader }}
                </slot>
            </p>

            <div v-if="state !== 'disabled'" :class="[{ 'mt-4': separateContent, 'content-loading': loading }, contentClass]" class="content">
                <div v-if="loading && !overlay" class="d-flex justify-content-center my-4 loading">
                    <b-spinner />
                </div>
                <slot v-else class="p-0"></slot>
            </div>
        </div>
    </b-overlay>
</template>



<script>
    import Tooltip from '@/components/common/Tooltip.vue';

    export default {
        name: 'Card',
        components: {
            Tooltip,
        },
        props: {
            header: {
                type: String,
                required: false,
            },
            subHeader: {
                type: String,
                required: false,
            },
            noPadding: {
                type: Boolean,
                default: false,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            noSeparateContent: {
                type: Boolean,
                default: false,
            },
            headerBorder: {
                type: Boolean,
                default: false,
            },
            state: {
                type: String,
                default: 'default',
                validator(val) {
                    return ['default', 'disabled', 'completed'].includes(val);
                },
            },
            blankLoading: {
                type: Boolean,
                default: false,
            },
            overlay: {
                type: Boolean,
                default: false,
            },
            contentClass: {
                type: [String, Array, Object],
                default: () => '',
            },
            headerId: {
                type: String,
                default: null,
            },
            tooltip: {
                type: String,
                default: null,
            },
            stickyHeader: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            separateContent() {
                return !this.noSeparateContent && (this.header || this.subHeader);
            },
            overlayShow() {
                return this.overlay && this.loading;
            },
        },
    };
</script>



<style lang="scss" scoped>
    @import 'bootstrap/scss/mixins';

    .state-completed {
        border: 2px solid $special-color;
        border-radius: 5px;
    }

    .state-completed-header {
        color: $special-color;
    }

    .state-disabled {
        opacity: 0.7;
    }
    .header-title {
        margin: 0;
        display: inline-flex;
        min-height: 40px;
        align-items: center;
        flex-grow: 0;
        margin-bottom: auto;
    }
    .sticky-header {
        background-color: $card-bg;
        position: sticky;
        top: $topbar-height + 80px;
        z-index: 15;
        padding: $card-spacer-x;
        margin: -$card-spacer-x !important;
        @include border-radius($card-border-radius);
    }
</style>
